<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Services'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
          <div class="flex heading-black1 justify-center uppercase font-serif">services / facilities</div>
          <div class="space-y-8">
            <div>
              <div class="heading-black2 font-serif">Reading Room Facility :-</div>
              <blockquote class="text-gray-600 text-justify font-medium">
                <p>The Central Library of institute has provision of spacious reading room for 150 students which offers
                  very peaceful ambience for students. It remains open normally from 9.30 am to 05:30pm.</p>
              </blockquote>
            </div>
            <div>
              <div class="heading-black2 font-serif"> Along with this library offers following facilities :-</div>
              <div>
                <Tree :value="Nodes"></Tree>
              </div>
            </div>
            <div class="space-y-4">
              <div class="heading-black2 font-serif">Circulation, Membership and Duration Period :-</div>
              <blockquote class="text-gray-600 text-justify font-medium">
                <p>
                  All the Students, Faculty members and Staff of the Institute are entitled for the membership of
                  library. The details of membership, allowed number of books for issue and loan period are given
                  below:</p>
              </blockquote>
              <div>
                <DataTable :value="Books" :rowHover="true">
                  <Column field="no" header="Sr.No."></Column>
                  <Column field="category" header="Category"></Column>
                  <Column field="books" header="No. of Books"></Column>
                  <Column field="lPeriod" header="Loan Period"></Column>
                </DataTable>
              </div>
            </div>
            <div>
              <div class="heading-black2 font-serif">Support for Self Learning:-</div>
              <blockquote class="text-gray-600 text-justify font-medium">
                <p>For the self learning adequate resources are available such as; rich set of e-books in Library which
                  includes Reference books and Text books. E-resources access to DELNET, NDL ,Competitive exam
                  preparation, Daily Newspapers, MOOC’s (Massive Open Online Courses) related to Curriculum and beyond
                  the curriculum is provided via the links on the Institute’s web portal. Reading room with ambience
                  adds to the facilities for self learning</p>
              </blockquote>
            </div>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import Tree from 'primevue/tree';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
  name: "Services",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent, Tree, DataTable, Column,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      Nodes: [
        {
          key: 0,
          label: 'Open access facility to all users.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 1,
          label: 'Home lending of books using E-library Manager software which has the facility of decrypting the barcode.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 2,
          label: 'Book Bank facility for SC/ST students.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 3,
          label: 'OPAC facility.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 4,
          label: 'Separate digital library equipped with 20 Nos. of computer with internet and Intranet facilities.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 5,
          label: 'Reprographic facility.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 6,
          label: 'Scanning facility.',
          icon: "pi pi-chevron-right",
        },
        {
          key: 7,
          label: 'NPTEL videos facility.',
          icon: "pi pi-chevron-right",
        },
      ],
      Books: [
        {
          no: "01",
          category: "Faculty",
          books: "05",
          lPeriod: "One week"
        },
        {
          no: "02",
          category: "Visiting Faculty",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "03",
          category: "FE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "04",
          category: "SE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "05",
          category: "TE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "06",
          category: "BE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "07",
          category: "ME Students",
          books: "02",
          lPeriod: "Fourteen Days"
        },
        {
          no: "08",
          category: "FE,SE,TE,BE Students (Book Bank Social Welfare)",
          books: "Set of 5 Books",
          lPeriod: "One Semester"
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>
